import { OdataFilters, queryCollection } from "helpers/reqparams";
import { alertRequest, body, downloadFileHandler, request } from "services/request";

const resource = "api/routeControlPoints";
const bidRouteControlPoints = "api/bidRouteControlPoints";
const distributionBidRouteControlPoints = "api/distributionBidRouteControlPoints";
const defaultQuery = {
    orderBy: "id desc",
};

const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const withDeleted = ["true", "all"].includes(params.customFilters?.isDeleted?.value as string);
    const query = queryCollection(params, { filter: { ...preparedFilter }, ...defaultQuery }).substr(1);
    return request(
        `${resource}/getPoints?withDeleted=${withDeleted}&${query}`,
        { method: "GET" },
        { countInHeaders: true },
    );
};

const getListExcel = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: { ...preparedFilter }, ...defaultQuery });
    return request(`${resource}/getListExcel${query}`, { method: "GET" }, { withoutMiddleware: true }).then((res) =>
        downloadFileHandler(res, "Точки контроля маршрута.xlsx"),
    );
};

const apply = (params: {}) => alertRequest(`${resource}/applyPoint`, body(params));

const delItem = (params: {}) => alertRequest(`${resource}/deletePoint`, body(params));

const restoreItem = (params: {}) => alertRequest(`${resource}/restorePoint`, body(params));

const getItem = ({ id }: { id: number }) => request(`${resource}/getPoint/${id}`, { method: "GET" });

const getBidItem = (bidId: number) => request(`${bidRouteControlPoints}/getPoints/${bidId}`, { method: "GET" });

const getDistributionBidItem = (bidId: number) =>
    request(`${distributionBidRouteControlPoints}/getPoints/${bidId}`, { method: "GET" });

const importFromExcel = (params: {}) =>
    request(`${resource}/importFromExcel`, params, { withoutMiddleware: true }).then((res: Response) => res.json());

export {
    apply,
    delItem,
    restoreItem,
    index,
    getItem,
    getBidItem,
    getDistributionBidItem,
    getListExcel,
    importFromExcel,
};
